import { post } from "./ajax";
import notificationToast from "./notification-toast.js";

export default class LSCategory {
    constructor() {
        this.thumbnailUploader = null;
        this.submitbutton = null;
        this.isSubmitting = false;   
        this.init();
        this.setupValidationRules()
    }

    init() {

        jQuery(document.body)
            .on("click", "#ls_upload_category_thumbnail", this.openThumbnailUploader.bind(this))
            .on("click", "#ls_remove_category_thumbnail", this.removeThumbnail.bind(this))
            .on("submit", "#ls_category_insert_form", this.lsCategoryForm.bind(this))
            .on("click", "#wp_list_delete_ls_category", this.tablelistChannelCategoryDelete.bind(this));

    }

    openThumbnailUploader(event) {
        event.preventDefault();

        if (this.thumbnailUploader) {
            this.thumbnailUploader.open();
            return;
        }

        this.thumbnailUploader = wp.media({
            title: 'upload image',
            multiple: false,
            library: { type: 'image' } 
        });

        this.thumbnailUploader.on('select', () => {
            const attachment = this.thumbnailUploader.state().get('selection').first().toJSON();
            let fileType = attachment.subtype;

            const allowedTypes = LSAjax.allow_image_type;
            if (!allowedTypes.includes(fileType)) {
                notificationToast.error(LSAjax.errorMessages.error_invalid_image, 'Error')
            } else {
                this.updateThumbnail(attachment);
            }
        });

        this.thumbnailUploader.open();
    }

    updateThumbnail(attachment) {
        jQuery('#ls_thumbnail_container').html(`
            <img src="${attachment.url}" alt="Thumbnail" style="max-width: 150px;">
        `);
        jQuery('#thumbnail_id').val(attachment.id);
    }

    removeThumbnail(event) {
        event.preventDefault();
        jQuery('#ls_thumbnail_container').empty();
        jQuery('#thumbnail_id').val('');
    }

    lsCategoryForm(event) {
        event.preventDefault();
        this.submitbutton= jQuery(event.currentTarget).find('input[type="submit"], button[type="submit"]');

        this.submitbutton.attr('type', 'button');


        const formData = new FormData(jQuery('#ls_category_insert_form')[0]);

        const currentFrom = jQuery(event.currentTarget);
        const validator = currentFrom.validate();
        if (currentFrom.valid()) {
            formData.get('term_id') ? this.updateCategory(formData) : this.addCategory(formData);
        } else {
            this.submitbutton.attr('type', 'submit');
            notificationToast.error(LSAjax.errorMessages.error_common, 'Error');
        }

    }

    setupValidationRules() {
        let baseRules = {
            name: {
                required: true,
            },
            slug: {
                required: true
            },
            thumbnail_id: {
                required: true
            }
        };

        let baseMessages = {
            name: {
                required: LSAjax.errorMessages.error_category_name,
            },
            slug: {
                required: LSAjax.errorMessages.error_category_slug,
            },
            thumbnail_id: {
                required: LSAjax.errorMessages.error_category_thumbnail
            }
        };

        jQuery('#ls_category_insert_form').validate({
            ignore: [],
            onsubmit: false,
            errorClass: "error-msg",
            errorElement: "p",
            rules: baseRules,
            messages: baseMessages,
            errorPlacement: function (error, element) {
                element.closest('.form-field').append(error);
            },
        })
    }


    addCategory(data) {
        post('ls_add_category', data).then(response => {
            if (response.success) {
                notificationToast.success(response.data.message, 'Success');
                window.location.reload();
            } else {
                notificationToast.error(response.data.message, 'Error');
                this.submitbutton.attr('type', 'submit');

            }
        }).catch(error => {
            // Check if error response contains a message in a custom format from the server
            if (error.responseJSON.data.message) {
                notificationToast.error(error.responseJSON.data.message, 'Error');
            } 

            this.submitbutton.attr('type', 'submit');
        });
    }



    updateCategory(data) {
        post('ls_update_category', data).then(response => {
            if (response.success) {
                notificationToast.success(response.data.message || LSAjax.errorMessages.success_category_update, 'Success');
                window.location.reload();
            } else {
                notificationToast.error(response.data.message, 'Error');
                this.submitbutton.attr('type', 'submit');
            }
        }).catch(error => {
            // Check if error response contains a message in a custom format from the server
            if (error.responseJSON.data.message) {
                // Show the server error message
                notificationToast.error(error.responseJSON.data.message, 'Error');
            } 

            this.submitbutton.attr('type', 'submit');
        });
    }

    tablelistChannelCategoryDelete(event) {
        event.preventDefault();
        const target = event.target;

        // Attempt to get the href attribute from the target
        let href = jQuery(target).attr("href");

        if (href === undefined) {
            const closestElement = jQuery(target).closest('.change_ls_category_status');
            if (closestElement.length) {
                href = closestElement.attr("href");
            }
        }

        if (!href) {
            return;
        }

        const params = new URLSearchParams(href.split('?')[1]);
        const action = params.get('action');
        const id = params.get('id');

        // Check if action and id are valid
        if (!action || !id) {
            return;
        }

        // Ask for confirmation
        const confirmed = window.confirm(LSAjax.category_delete_confirmation);
        if (!confirmed) {
            return; 
        }

        const data = {
            status: action,
            term_id: id
        };

        post('delete_tablelist_ls_category', data)
            .then(response => {
                if (response.success) {
                    notificationToast.success(response.data.message, 'Success');
                    location.reload();
                } else {
                    console.error(response.data.message);
                    notificationToast.error(response.data.message, 'Error');
                    location.reload();
                }
            })
            .catch(error => {
                notificationToast.error('An unexpected error occurred. Please try again.', 'Error');
                location.reload();
            });
    }

}